import { useNavigate } from 'react-router-dom';
import { LOCAL_STORAGE_KEYS, ROUTE_PATHS } from '@constants';
import { CAMPAIGN_SUBMIT_ERROR } from '@enums';
import { useStore } from '@hooks';
import { notification } from 'antd';

export const useOnLaunch = () => {
    const navigate = useNavigate();
    const store = useStore();
    const { setFormSubmitting, submitCampaign, campaign } = store.campaignWizardStore;

    const onLaunch = async () => {
        setFormSubmitting(true);
        // LaunchCheck is reached after Step5 / CampaignEdit have already persisted the user's
        // draft exclusions (via /sync or via BE submit-time rebuild on the prior attempt).
        // BE state is the source of truth here, so submit with empty selections.
        const data = await submitCampaign({ userIncludedIds: [], userExcludedIds: [] });
        setFormSubmitting(false);

        const hasPrelaunchedCampaign =
            data.notConfirmed.every((item) => item.name === 'hasPrelaunchedCampaign') &&
            data.notConfirmed?.length === 1;

        if ((data.ready && !data.notConfirmed?.length) || hasPrelaunchedCampaign) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.PROCESSING_CAMPAIGN, campaign.id);
            if (hasPrelaunchedCampaign) {
                localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_DEMO_PRODUCTS_MODAL, 'true');
            }
            navigate(ROUTE_PATHS.CAMPAIGNS);
        } else {
            Object.values(data.notConfirmed).map((error) => {
                notification.error({
                    message: 'Can not activate campaign',
                    description: CAMPAIGN_SUBMIT_ERROR[error.name],
                    duration: 0
                });
            });
        }
    };

    return onLaunch;
};
